<template>
    <div class="container menu-buttons">
        <div class="row row-cols-md-2 row-cols-1 d-flex">
            <div v-for="link in links" v-bind:key="link.id"  class="row main-link-container">
                <router-link class="main-link" v-bind:to="link.href" v-bind:style="'background-image: url(' + require('@/assets/home/'+ link.href + '.jpg') + ');'">
                    <div class="main-link-div" v-bind:style="'border-color:' + link.color">
                        <p class="link-label">{{link.label}}</p>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'MenuButtons',
  props:{
      links:Array
  }
}
</script>

<style>
    .menu-buttons{
        margin:auto;
        margin-bottom:50%;
        margin-top:20%;
    }
    .main-link-container{
        margin-bottom: 20px;
    }
    .main-link{
        text-decoration:none;
        font-weight:bold;
        background-size: cover;
        padding:0!important;
        margin-left:10px;
        color:black;
        width:90%;
    }
    .main-link-div{
        height:200px;
        width:100%;
        background-color:rgba(255,255,255,0.5);
        border-width:2px;
        border-style:solid;
    }
    .main-link-div:hover{
        background-color:rgba(255,255,255,0.8);
        border-width:5px;
    }
    .link-label{
        text-align:left;
        padding:10px;
        font-size:25px;
    }
    .link-label:hover {
        color:black !important;
    }
</style>
